<template>
    <v-content>
        <div class="content">
            <dashboard-core-app-bar/>
            <v-snackbar :value="dialog" absolute centered color="white" elevation="5" shaped top vertical :timeout="timeoutMS">
                <v-simple-table light>
                    <template v-slot:default>
                        <tbody class="subtitle-1">
                        <tr>
                            <td class="font-weight-bold">Name</td>
                            <td class="pl-2">:</td>
                            <td class="px-5">{{$store.state.home.user.fullName}}</td>
                        </tr>
                        <tr>
                            <td class="font-weight-bold">Branch</td>
                            <td class="pl-2">:</td>
                            <td class="px-5">{{$store.state.home.user.branch}}</td>
                        </tr>
                        </tbody>
                    </template>
                </v-simple-table>
                <v-divider></v-divider>
                <template>
                    <div class="d-flex justify-center mt-5">
                        <v-btn @click="dialog = false" class="mr-10" color="primary" small>
                            Close
                        </v-btn>
                        <v-btn @click="emitLogout" color="primary" dark small>
                            Logout
                        </v-btn>
                    </div>
                </template>
            </v-snackbar>
            <router-view/>
        </div>
        <Footer/>
    </v-content>
</template>

<script>
    import DashboardCoreAppBar from "./AppBar";
    import Footer from "./Footer";
    import {EventBus} from "@/_helpers";

    export default {
        name: "DashboardCoreView",
        components: {Footer, DashboardCoreAppBar},
        data() {
            return {
                dialog: false,
                timeoutMS: 0
            }
        },
        methods: {
            openModal: function () {
                this.dialog = true
            },
            emitLogout: function () {
                EventBus.$emit('logout')
            }
        },
        created() {
            EventBus.$on('openModal', this.openModal)
        }
    }
</script>
